var map = {
	".": "f16b",
	"./": "f16b",
	"./LICENSE.txt": "987e",
	"./README.md": "ce88",
	"./dict/adj.exc": "f64f",
	"./dict/adj.exc.json": "f64f",
	"./dict/adv.exc": "1db0",
	"./dict/adv.exc.json": "1db0",
	"./dict/index.adj": "7c3e",
	"./dict/index.adj.json": "7c3e",
	"./dict/index.adv": "2183",
	"./dict/index.adv.json": "2183",
	"./dict/index.noun": "354c",
	"./dict/index.noun.json": "354c",
	"./dict/index.verb": "c862",
	"./dict/index.verb.json": "c862",
	"./dict/noun.exc": "4586",
	"./dict/noun.exc.json": "4586",
	"./dict/verb.exc": "7d2b",
	"./dict/verb.exc.json": "7d2b",
	"./index": "f16b",
	"./index.js": "f16b",
	"./package": "80be",
	"./package.json": "80be",
	"./testing": "bf2c",
	"./testing.js": "bf2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4906";